import { render, staticRenderFns } from "./DossierCostBreakdown.vue?vue&type=template&id=43b7de63&scoped=true"
import script from "./DossierCostBreakdown.vue?vue&type=script&lang=js"
export * from "./DossierCostBreakdown.vue?vue&type=script&lang=js"
import style0 from "./DossierCostBreakdown.vue?vue&type=style&index=0&id=43b7de63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b7de63",
  null
  
)

export default component.exports